//Custom components
import { NumericFormat as NumberFormat } from 'react-number-format';
import StatCard from '../../../UI/Card/StatCard';

const ApprovedProjectsWidget = ({ count }: { count: number }) => {
  return <StatCard title='Approved Projects' stat={<NumberFormat value={count} displayType='text' thousandSeparator={true} />} />;
};

export default ApprovedProjectsWidget;
